// Single source of truth for the feedback destination -- update this one
// value (e.g. when a custom domain is set up in Canny) rather than editing
// every place a feedback link exists.
export const FEEDBACK_URL = 'https://ravenautomation.canny.io/scopeassistant'
